import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-1 text-stone-500 hover:text-pink-600 text-sm font-semibold mb-6">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-pink-500 mb-3">Legal</div>
        <h1 className="font-heading text-4xl lg:text-5xl font-black tracking-tighter text-stone-900">{title}</h1>
        {updated && <p className="text-sm text-stone-500 mt-2">Last updated: {updated}</p>}
        <div className="prose prose-stone max-w-none mt-8 leading-relaxed text-stone-700 text-base space-y-4
                        [&>h2]:font-heading [&>h2]:text-2xl [&>h2]:font-black [&>h2]:tracking-tight [&>h2]:text-stone-900 [&>h2]:mt-10 [&>h2]:mb-3
                        [&>h3]:font-heading [&>h3]:text-lg [&>h3]:font-bold [&>h3]:text-stone-900 [&>h3]:mt-6 [&>h3]:mb-2
                        [&>ul]:list-disc [&>ul]:pl-6 [&>ul>li]:my-1
                        [&>ol]:list-decimal [&>ol]:pl-6 [&>ol>li]:my-1">
          {children}
        </div>
        <div className="mt-16 border-t border-stone-200 pt-6 text-sm text-stone-500">
          Questions? Reach us at <a href="mailto:info@foldora.ca" className="text-pink-600 font-semibold hover:underline">info@foldora.ca</a>.
        </div>
      </div>
    </div>
  );
}
